<div *ngIf="isLoading">
    <app-loader></app-loader>
</div>